import { render, staticRenderFns } from "./RenderDataForPatient.vue?vue&type=template&id=68dff860"
import script from "./RenderDataForPatient.vue?vue&type=script&lang=js"
export * from "./RenderDataForPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports